import coreRenderFramework from './renderFramework'
import coreRenderAgent from './renderAgent'
import coreRenderWidget from './renderWidget'
import { RetorikFramework, RetorikAgent, RetorikWidget, RetorikNews } from './components'
import { presets } from '@davi-ai/react-bodyengine-three'
import fetchAvailableLanguages from './utils/fetchAvailableLanguages'
import getRetorikConfigs from './utils/getConfigs'
import getThemeColors from './utils/getThemeColors'

import {
  addDetailedAttachmentTrigger,
  cancelCurrentUtterance,
  closeWidget,
  hideAgent,
  openWidget,
  pauseConversation,
  playExternalSynthesis,
  resetActivityStore,
  resetAdaptiveCardStore,
  resetDirectlineStore,
  resetLocaleStore,
  resetRetorikStore,
  resetSpeechStore,
  resetUtilsStore,
  resumeConversation,
  sendActivity,
  sendEvent,
  sendMessage,
  sendMessageToChatbot,
  setAgentData,
  setCurrentCustomView,
  setCurrentSubView,
  setDashboardOpened,
  setDisplaySubtitles,
  addExternalActivityHandler,
  setExternalActivityHandlers,
  setLoaderClosed,
  setLocale,
  setModalFullscreenContent,
  setMode,
  setMuted,
  setVisibility,
  showAgent,
  toggleDisplay,
  toggleMicrophone,
  toggleSubtitles,
  toggleVisibility,
  toggleWidget
} from './components/Contexts/InputOutputHandler'

import {
  useCurrentSubView,
  useKioskParameterOpening,
  useRetorikEvent,
  useLocale,
  useMode,
  useMuted,
  useLoaderClosed,
  useConfiguration,
  useIsUsedOnBorne,
  useIsMobile,
  useIsWidget,
  useIsRTL,
  useTranslation,
  useThemeColors
} from './hooks/external'

const resetStores = () => {
  resetLocaleStore()
  resetUtilsStore()
  resetRetorikStore()
  resetSpeechStore()
  resetActivityStore()
  resetDirectlineStore()
  resetAdaptiveCardStore()
}

const renderFramework = coreRenderFramework.bind(null, RetorikFramework)
const renderAgent = coreRenderAgent.bind(null, RetorikAgent)
const renderWidget = coreRenderWidget.bind(null, RetorikWidget)
const setPrintingCallback = (value: ((url: string) => void) | null) => {
  window.Retorik._printingCallback = value
}

export default RetorikAgent

export {
  RetorikFramework,
  RetorikAgent,
  RetorikWidget,
  RetorikNews,
  renderAgent,
  addDetailedAttachmentTrigger,
  cancelCurrentUtterance,
  closeWidget,
  fetchAvailableLanguages,
  getRetorikConfigs,
  getThemeColors,
  hideAgent,
  openWidget,
  pauseConversation,
  playExternalSynthesis,
  resumeConversation,
  resetStores,
  sendActivity,
  sendEvent,
  sendMessage,
  sendMessageToChatbot,
  setCurrentCustomView,
  setCurrentSubView,
  setDashboardOpened,
  setDisplaySubtitles,
  setLoaderClosed,
  setLocale,
  setModalFullscreenContent,
  setMode,
  setMuted,
  setPrintingCallback,
  setVisibility,
  showAgent,
  toggleDisplay,
  toggleMicrophone,
  toggleSubtitles,
  toggleVisibility,
  toggleWidget,
  useConfiguration,
  useCurrentSubView,
  useIsMobile,
  useIsRTL,
  useIsUsedOnBorne,
  useIsWidget,
  useKioskParameterOpening,
  useLoaderClosed,
  useLocale,
  useMode,
  useMuted,
  useRetorikEvent,
  useTranslation,
  useThemeColors
}

export type {
  AddressData,
  AgentData,
  AvailableLanguages,
  BackgroundOptions,
  BaseAgentData,
  ChatbotData,
  Configuration,
  CustomMenu,
  CustomVoice,
  GDPR,
  MapConfiguration,
  NewsConfig,
  PonyfillFactoryCredentials,
  RetorikMenusConfiguration,
  UserData,
  VeilleConfiguration,
  View,
  ViewsConfiguration,
  WidgetConfiguration
} from './models/types'
export type { RetorikMainComponentProps, RetorikMainComponentConfiguration, RetorikSharedProps } from './models/retorikTypes'
export type { POIContentType } from './models/attachmentTypes'
export type { RetorikThemeColors } from './models/colorTypes'

export { presets }
export { CONTENT_TYPE_POI, CONTENT_TYPE_NEWS, CONTENT_TYPE_ADAPTIVE_CARD } from './models/attachmentTypes'

export { AvailableViews, AvailableSubViews, RetorikEvent, CurrentSubView, DeviceType, Emotions, InputHintBehaviour } from './models/enums'

window.Retorik = {
  ...window.Retorik,
  renderFramework,
  renderAgent,
  renderWidget,
  addDetailedAttachmentTrigger,
  addExternalActivityHandler,
  cancelCurrentUtterance,
  changeAgent: setAgentData,
  displaySubtitles: setDisplaySubtitles,
  hideAgent,
  pauseConversation,
  playExternalSynthesis,
  resumeConversation,
  sendActivity,
  sendEvent,
  sendMessage,
  sendMessageToChatbot,
  setExternalActivityHandlers,
  setLocale,
  setModalFullscreenContent,
  setMuted,
  setVisibility,
  showAgent,
  toggleMicrophone,
  toggleSubtitles,
  toggleVisibility
}
